/**
 * IcpHealthMetrics Component
 *
 * Health metrics panel for Internet Computer (ICP) network.
 */

import { Icons } from '../Icons';
import { GenericHealthMetrics, networkConfigs } from '../common/GenericHealthMetrics';
import type { IcpNetworkMetrics } from '../../services/blockchainHealthApi';

const ICP_COLOR = '#29ABE2';

function renderIcpMetrics(metrics: Record<string, any>) {
  const m = (metrics || {}) as IcpNetworkMetrics;
  return (
    <>
      {/* Total Subnets */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Layers size={24} style={{ color: ICP_COLOR, marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: ICP_COLOR }}>
          {m.totalSubnets ?? 0}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Subnets
        </div>
      </div>

      {/* Total Nodes */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Server size={24} style={{ color: '#522785', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#522785' }}>
          {(m.totalNodes ?? 0).toLocaleString()}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Nodes
        </div>
      </div>

      {/* Canisters */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Package size={24} style={{ color: '#10b981', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#10b981' }}>
          {m.totalCanisters ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Canisters
        </div>
      </div>

      {/* TPS */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Zap size={24} style={{ color: '#f59e0b', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#f59e0b' }}>
          {(m.tps ?? 0).toLocaleString()}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          TPS
        </div>
      </div>

      {/* Staking APY */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.TrendingUp size={24} style={{ color: '#22c55e', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#22c55e' }}>
          {m.stakingAPY ?? 0}%
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Staking APY
        </div>
      </div>
    </>
  );
}

export function IcpHealthMetrics() {
  const config = {
    ...networkConfigs.icp,
    renderNetworkMetrics: renderIcpMetrics,
  };

  return <GenericHealthMetrics config={config} />;
}
